import React, { useState } from "react";
import { NavBar as DSNav } from "widgets/NavBar";
import { Menu } from "design_system/Menu";
import { Globe2 } from "design_system/Icon";
import { createFormData } from "../../utils/fetch";
import { LOCALES, NAV_MENU_V3_ENGAGEMENTS, localesToEngagementsMap } from "./constants";
import { recordPatientAppClickEngagement } from "../../utils/engagements";

async function handleLanguageChange(csrfToken: string, locale: string, setLanguageUrl: string) {
    try {
        const engagementEvent =
            localesToEngagementsMap[locale as keyof typeof localesToEngagementsMap];
        if (engagementEvent) {
            recordPatientAppClickEngagement(engagementEvent);
        }
        const body = createFormData({
            csrfmiddlewaretoken: csrfToken,
            language: locale,
        });
        const res = await fetch(setLanguageUrl, {
            method: "POST",
            body,
            headers: { Accept: "application/json" },
        });
        if (res.ok) {
            window.location.reload();
        }
    } catch (e) {
        console.error("Error on calling set_language");
    }
}

interface LanguageSelectorProps {
    patientAppAuthContext: {
        csrfToken: string;
    };
    patientAppLocaleContext: {
        locale: string;
        setLanguageUrl: string;
    };
}
export const LanguageSelector = ({
    patientAppAuthContext,
    patientAppLocaleContext,
}: LanguageSelectorProps) => {
    const [locale, setLocale] = useState<string>(patientAppLocaleContext.locale);

    const ariaLabel = gettext(`Language selection graphic menu ${LOCALES[locale]} selected`);
    return (
        <Menu>
            <DSNav.TopBar.MenuButton
                narrowIcon={<Globe2 />}
                narrowAriaLabel={ariaLabel}
                onClick={() =>
                    recordPatientAppClickEngagement(NAV_MENU_V3_ENGAGEMENTS.LANGUAGE_DROPDOWN_BTN)
                }
            >
                {LOCALES[locale]}
            </DSNav.TopBar.MenuButton>
            <Menu.Items>
                {Object.keys(LOCALES).map((key: string) => (
                    <Menu.Item
                        key={key}
                        onClick={() => {
                            if (locale !== key) {
                                handleLanguageChange(
                                    patientAppAuthContext.csrfToken,
                                    key,
                                    patientAppLocaleContext.setLanguageUrl,
                                );
                                setLocale(key);
                            }
                        }}
                    >
                        {LOCALES[key]}
                    </Menu.Item>
                ))}
            </Menu.Items>
        </Menu>
    );
};
